/**
 * 재등록 수업료 판정에 필요한 양도 기록 조회 실패(서버 10/18 G1, ptTierIssueKindFallback.service).
 *
 * 서버는 조회가 실패하면 기본 요율로 계산해 내보내지 않고 요청 전체를 503 `SETTLEMENT_TRANSFER_LOOKUP_FAILED` 로 끝낸다.
 * 급여 계산 조회·저장, 수업료 정산(수강권별·엑셀), 매출 달력이 이 응답을 받을 수 있다.
 * 화면은 이 경우를 빈 화면·0원으로 보이지 않고 오류 상태로 보인다.
 *
 * 급여 저장(POST)은 저장 **전에** 조회하므로(서버 salaryCalc.controller updateCenterSalaryCalc) 이 503 이면 저장되지 않았다.
 */
export const SETTLEMENT_TRANSFER_LOOKUP_FAILED = 'SETTLEMENT_TRANSFER_LOOKUP_FAILED';

export const SETTLEMENT_TRANSFER_LOOKUP_FAILED_MESSAGE =
    '재등록 수업료 확인 중 일시적인 문제가 있었어요. 잠시 후 다시 시도해 주세요.';

/** axios 응답(상태·본문)이 그 503 인가. 코드까지 맞아야 한다(프록시 503 은 해당 없음). */
export const isSettlementTransferLookupFailure = (status: unknown, data: unknown): boolean =>
    status === 503 &&
    !!data &&
    typeof data === 'object' &&
    (data as { errorCode?: unknown }).errorCode === SETTLEMENT_TRANSFER_LOOKUP_FAILED;

/** 조회 함수가 던지는 오류 — React Query 가 성공으로 캐시하지 않게 결과가 아니라 오류로 던진다. */
export class SettlementTransferLookupError extends Error {
    readonly status = 503;

    readonly errorCode = SETTLEMENT_TRANSFER_LOOKUP_FAILED;

    constructor() {
        super(SETTLEMENT_TRANSFER_LOOKUP_FAILED_MESSAGE);
        this.name = 'SettlementTransferLookupError';
    }
}

export const isSettlementTransferLookupError = (error: unknown): error is SettlementTransferLookupError =>
    error instanceof SettlementTransferLookupError ||
    (!!error && typeof error === 'object' && (error as { errorCode?: unknown }).errorCode === SETTLEMENT_TRANSFER_LOOKUP_FAILED);
